var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "div",
          { staticClass: "form-group mb-2" },
          [
            _c("small", { staticClass: "input-title" }, [
              _vm._v("Tel. Casa: "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.phone,
                  expression: "data.phone",
                },
              ],
              staticClass: "form-control form-control-sm",
              class: _vm.errors.phone ? "is-invalid" : "",
              attrs: { type: "text" },
              domProps: { value: _vm.data.phone },
              on: {
                keypress: _vm.NUMBER,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "phone", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.errors.phone, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "div",
          { staticClass: "form-group mb-2" },
          [
            _c("small", { staticClass: "input-title" }, [
              _vm._v("Tel. Celular: "),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.mobil,
                  expression: "data.mobil",
                },
              ],
              staticClass: "form-control form-control-sm",
              class: _vm.errors.mobil ? "is-invalid" : "",
              attrs: { type: "text" },
              domProps: { value: _vm.data.mobil },
              on: {
                keypress: _vm.NUMBER,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "mobil", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.errors.mobil, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6" }, [
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "w-75" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Tel. Trabajo: "),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.phone_work,
                      expression: "data.phone_work",
                    },
                  ],
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.phone_work ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.phone_work },
                  on: {
                    keypress: _vm.NUMBER,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "phone_work", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.phone_work, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-25 pl-2" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [_vm._v("Ext.: ")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.phone_work_ext,
                      expression: "data.phone_work_ext",
                    },
                  ],
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.phone_work_ext ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.phone_work_ext },
                  on: {
                    keypress: _vm.NUMBER,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "phone_work_ext", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.phone_work_ext, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "div",
          { staticClass: "form-group mb-2" },
          [
            _c("small", { staticClass: "input-title" }, [_vm._v("Otro: ")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.phone_other,
                  expression: "data.phone_other",
                },
              ],
              staticClass: "form-control form-control-sm",
              class: _vm.errors.phone_other ? "is-invalid" : "",
              attrs: { type: "text" },
              domProps: { value: _vm.data.phone_other },
              on: {
                keypress: _vm.NUMBER,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "phone_other", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.errors.phone_other, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "div",
          { staticClass: "form-group mb-2" },
          [
            _c("small", { staticClass: "input-title" }, [
              _vm._v("Entregar en: "),
            ]),
            _vm._v(" "),
            _c("v-select", {
              staticClass: "form-control form-control-sm",
              class: _vm.errors.branch ? "is-invalid" : "",
              attrs: { items: _vm.delivers, "hide-details": "" },
              on: { change: _vm.FRESH },
              model: {
                value: _vm.data.deliver_to,
                callback: function ($$v) {
                  _vm.$set(_vm.data, "deliver_to", $$v)
                },
                expression: "data.deliver_to",
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.errors.deliver_to, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.data.deliver_to == 1
        ? _c("div", { staticClass: "col-lg-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Sucursal: "),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.branch_office_id ? "is-invalid" : "",
                  attrs: {
                    "item-value": "id",
                    "item-text": "name",
                    items: _vm.branch_offices,
                    "hide-details": "",
                  },
                  model: {
                    value: _vm.data.branch_office_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "branch_office_id", $$v)
                    },
                    expression: "data.branch_office_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.branch_office_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ])
        : _c("div", { staticClass: "col-lg-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Dirección: "),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.address,
                      expression: "data.address",
                    },
                  ],
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.address ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.address },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "address", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.address, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
    ]),
    _vm._v(" "),
    _vm.data.deliver_to == 0
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [_vm._v("País: ")]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.country_id ? "is-invalid" : "",
                  attrs: {
                    items: _vm.countries,
                    "item-text": "name",
                    "item-value": "id",
                    "hide-details": "",
                  },
                  on: { change: _vm.PROVINCES },
                  model: {
                    value: _vm.data.country_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "country_id", $$v)
                    },
                    expression: "data.country_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.country_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Provincia: "),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.province_id ? "is-invalid" : "",
                  attrs: {
                    items: _vm.provinces,
                    "item-text": "name",
                    "item-value": "id",
                    "hide-details": "",
                  },
                  on: { change: _vm.CITIES },
                  model: {
                    value: _vm.data.province_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "province_id", $$v)
                    },
                    expression: "data.province_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.province_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Cuidad: "),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.city_id ? "is-invalid" : "",
                  attrs: {
                    items: _vm.cities,
                    "item-text": "name",
                    "item-value": "id",
                    "hide-details": "",
                  },
                  on: { change: _vm.DISTRICTS },
                  model: {
                    value: _vm.data.city_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "city_id", $$v)
                    },
                    expression: "data.city_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.city_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-3" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Distrito: "),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.district_id ? "is-invalid" : "",
                  attrs: {
                    items: _vm.districts,
                    "item-text": "name",
                    "item-value": "id",
                    "hide-details": "",
                  },
                  model: {
                    value: _vm.data.district_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "district_id", $$v)
                    },
                    expression: "data.district_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.district_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }